import { Subject } from "rxjs";

export interface TerminalMessage {
	// Content of the message
	content: string;
	// Did the message come from a remote source?
	remote: boolean;
}

// An observable subject of the stdout
export const terminalStdout = new Subject<TerminalMessage>();
